import * as React from "react"
import { useEffect } from "react"
import { useSignal } from "@preact/signals-react"
import { Box, Typography } from "@mui/material"
import { AppLink } from "@ui-seeker/app"
import { ButtonIconSeeker, PopoverSeeker, PopoverSeekerItem } from "@ui-seeker/core"


export default function TitleWithPopover({ title, enabledExcel=false, enabledPDF=false, forceClosePopover=false, propsExcel={}, propsPdf={}, goTo=null, showIcon=null, children }) {
    const isOpenPopover = useSignal(null)

    useEffect(() => {
        if (forceClosePopover)
            isOpenPopover.value = null
    }, [forceClosePopover])

    return <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
		<Typography variant="subtitle2">
            {title}
        </Typography>

        {(enabledExcel || enabledPDF || goTo || showIcon) && <ButtonIconSeeker
            icon="circle-ellipsis"
            iconWeight="light"
            iconProps={{ fontSize: 15 }}
            onClick={e => {
                e.stopPropagation()
                isOpenPopover.value = e.currentTarget
            }}
        />}

        <PopoverSeeker anchorEl={isOpenPopover.value} onClose={e => isOpenPopover.value = null}>
            { enabledExcel && <PopoverSeekerItem icon="cloud-arrow-down" label="Download Excel" {...propsExcel} />}
            { enabledPDF && <PopoverSeekerItem icon="file-pdf" label="Download PDF" {...propsPdf} />}
            { goTo && <AppLink to={goTo} target="_blank">
                <PopoverSeekerItem icon="arrow-up-right-from-square" label="Go to details" />
            </AppLink> }
            {children}
        </PopoverSeeker>
    </Box>
}